import { Component, OnInit } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { LocationsTurnsService } from 'src/app/services/turns-services/locations-turns-service/locations-turns.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { Desk } from 'src/app/models/turns-models/desk.model';
import { Location } from 'src/app/models/turns-models/location.model';
import { Center } from 'src/app/models/center-model/center.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-turns-controls-controls-card',
  templateUrl: './turns-controls-controls-card.component.html',
  styleUrls: ['./turns-controls-controls-card.component.scss']
})
export class TurnsControlsControlsCardComponent implements OnInit {

  centerList;
  deskList;
  locationList;
  turnList;
  showSelectDesk: boolean;
  showSelectLocation: boolean;
  showLocations: boolean;
  showLocationsButtons: boolean;
  showNextTurn: boolean;
  showLocationLiveInfo: boolean;
  locationLiveInfo;
  basicDataForm = new FormGroup({
    selectedCenter: new FormControl(null, Validators.required),
    selectedDesk: new FormControl({ value: null, disabled: true }),
    selectedLocation: new FormControl({ value: null, disabled: true })
  });
  getDesksSubscription: Subscription;
  getLocationsSubscription: Subscription;
  getTurnsByLocationSubscription: Subscription;
  nextTurnSubscription: Subscription;
  openLocationSubscription: Subscription;
  closelocationSubscription: Subscription;
  nextDeskLocationSubscription: Subscription;
  getlocationLiveInfoSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
    private snackbarService: SnackBarService,
    private translateService: TranslateService,
    private locationsTurnsService: LocationsTurnsService,
    private desksTurnsService: DesksTurnsService) { }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    if (this.cacheExists()['center']) {
      this.basicDataForm.patchValue({
        selectedCenter: this.cacheExists()['center']
      });
      this.centerSelectedChanged(null);
    }
  }

  public getDesks() {
    this.basicDataForm.get('selectedDesk').disable();
    this.getDesksSubscription = this.desksTurnsService.getDesks().subscribe(
      (res) => {
        this.deskList = this.filterDesks(res);
        if (this.cacheExists()['desk']) {
          this.basicDataForm.patchValue({
            selectedDesk: this.cacheExists()['desk']
          });
          this.deskSelectedChanged(null);
        }
        this.basicDataForm.get('selectedDesk').enable();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getLocations() {
    this.basicDataForm.get('selectedLocation').disable();
    this.getLocationsSubscription = this.locationsTurnsService.getLocationList().subscribe(
      (res) => {
        this.locationList = this.filterLocations(res);
        if (this.cacheExists()['location']) {
          this.basicDataForm.patchValue({
            selectedLocation: this.cacheExists()['location']
          });
          this.locationSelectedChanged(null);
        }
        this.basicDataForm.get('selectedLocation').enable();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getLocationStatus(status) {
    if (this.locationLiveInfo) {
      return this.translateService.instant(status);
    }
  }

  public centerSelectedChanged($event) {
    this.getDesks();
    this.getLocations();
    this.rememberCenter(this.basicDataForm.get('selectedCenter').value);
    this.showSelectDesk = true;
    this.showSelectLocation = true;
    this.showNextTurn = false;
    this.showLocations = false;
    this.showLocationsButtons = false;
    this.showLocationLiveInfo = false;
    this.basicDataForm.patchValue({
      selectedDesk: null,
      selectedLocation: null
    });
  }

  public deskSelectedChanged($event) {
    this.rememberDesk(this.basicDataForm.get('selectedDesk').value);
    this.showNextTurn = true;
  }

  public locationSelectedChanged($event) {
    this.rememberLocation(this.basicDataForm.get('selectedLocation').value);
    this.getLocationLiveInfo();
    this.showLocationsButtons = true;
  }

  public nextTurn() {
    this.showNextTurn = false;
    const deskId = this.basicDataForm.get('selectedDesk').value.InternalId;
    this.nextTurnSubscription = this.desksTurnsService.pushTurn(deskId).subscribe(
      (res) => {
        this.showNextTurn = true;
        this.snackbarService.open(res['message'], 'success');
      },
      (error) => {
        this.showNextTurn = true;
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public callBackLastTurn() {
    this.showNextTurn = false;
    const deskId = this.basicDataForm.get('selectedDesk').value.InternalId;
    this.nextTurnSubscription = this.desksTurnsService.callBackLastTurn(deskId).subscribe(
      (res) => {
        this.showNextTurn = true;
        this.snackbarService.open(res['message'], 'success');
      },
      (error) => {
        this.showNextTurn = true;
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public openLocation() {
    this.showLocationLiveInfo = false;
    const locationId = this.basicDataForm.get('selectedLocation').value.InternalId;
    this.openLocationSubscription = this.locationsTurnsService.openLocation(locationId).subscribe(
      (res) => {
        this.getLocationLiveInfo();
        this.snackbarService.open(res['message'], 'success');
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public closeLocation() {
    this.showLocationLiveInfo = false;
    const locationId = this.basicDataForm.get('selectedLocation').value.InternalId;
    this.closelocationSubscription = this.locationsTurnsService.closeLocation(locationId).subscribe(
      (res) => {
        this.getLocationLiveInfo();
        this.snackbarService.open(res['message'], 'success');
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public nextDeskLocation() {
    this.showLocationLiveInfo = false;
    this.nextDeskLocationSubscription = this.locationsTurnsService.nextDeskLocation(this.basicDataForm.get('selectedLocation').value.InternalId).subscribe(
      (res) => {
        this.getLocationLiveInfo();
        this.snackbarService.open(res['message'], 'success');
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public callBackLastDeskLocation() {
    this.showLocationLiveInfo = false;
    this.nextDeskLocationSubscription = this.locationsTurnsService.callBackLastTurnAtLocation(this.basicDataForm.get('selectedLocation').value.InternalId).subscribe(
      (res) => {
        this.getLocationLiveInfo();
        this.snackbarService.open(res['message'], 'success');
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public requeueLastDeskLocation() {
    this.showLocationLiveInfo = false;
    this.nextDeskLocationSubscription = this.locationsTurnsService.requeueLastTurnAtLocation(this.basicDataForm.get('selectedLocation').value.InternalId).subscribe(
      (res) => {
        this.getLocationLiveInfo();
        this.snackbarService.open(res['message'], 'success');
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getLocationLiveInfo() {
    this.showLocationLiveInfo = false;
    const locationId = this.basicDataForm.get('selectedLocation').value.InternalId;
    this.getlocationLiveInfoSubscription = this.locationsTurnsService.getLocationLiveInfo(locationId).subscribe(
      (res) => {
        this.locationLiveInfo = res;
        this.showLocationLiveInfo = true;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private filterDesks(desks) {
    return desks.filter(d => (d.CenterInternalId === this.basicDataForm.get('selectedCenter').value.InternalId) && (d.TurnTypeInternalId === 'MSHMV1BJ9THXZL9CIYPT25T6R7427OY42'));
  }
  private filterLocations(locations) {
    return locations.filter(l => l.CenterInternalId === this.basicDataForm.get('selectedCenter').value.InternalId);
  }
  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }
  public getColor() {
    if (this.locationLiveInfo) {
      switch (this.locationLiveInfo.status) {
        case 'AVAIABLE':
          return 'success';
        case 'CLOSED':
          return 'error';
        case 'ATTENDING':
          return 'warning';
      }
    }
  }

  public cacheExists() {
    const c = new Center();
    const d = new Desk();
    const l = new Location();
    try {
      Object.assign(c, JSON.parse(sessionStorage.getItem('cache_ctcc')));
      Object.assign(d, JSON.parse(sessionStorage.getItem('cache_ctcd')));
      Object.assign(l, JSON.parse(sessionStorage.getItem('cache_ctcl')));
    } catch (e) { return false; }
    const center = c.InternalId ? c : null;
    const desk = d.InternalId ? d : null;
    const location = l.InternalId ? l : null;
    return { center, desk, location };
  }

  public rememberCenter(center) {
    try {
      sessionStorage.removeItem('cache_ctcc');
      sessionStorage.setItem('cache_ctcc', JSON.stringify(Object.assign(new Center(), center)));
    } catch (e) { console.dir('Can not save info at session storage'); }
  }

  public rememberDesk(desk) {
    try {
      sessionStorage.removeItem('cache_ctcd');
      sessionStorage.setItem('cache_ctcd', JSON.stringify(Object.assign(new Desk(), desk)));
    } catch (e) { console.dir('Can not save info at session storage'); }
  }

  public rememberLocation(location) {
    try {
      sessionStorage.removeItem('cache_ctcl');
      sessionStorage.setItem('cache_ctcl', JSON.stringify(Object.assign(new Location(), location)));
    } catch (e) { console.dir('Can not save info at session storage'); }
  }

  ngDestroy() {
    if (this.getDesksSubscription) { this.getDesksSubscription.unsubscribe(); }
    if (this.getLocationsSubscription) { this.getLocationsSubscription.unsubscribe(); }
    if (this.getTurnsByLocationSubscription) { this.getTurnsByLocationSubscription.unsubscribe(); }
    if (this.nextTurnSubscription) { this.nextTurnSubscription.unsubscribe(); }
    if (this.openLocationSubscription) { this.openLocationSubscription.unsubscribe(); }
    if (this.closelocationSubscription) { this.closelocationSubscription.unsubscribe(); }
    if (this.nextDeskLocationSubscription) { this.nextDeskLocationSubscription.unsubscribe(); }
    if (this.getlocationLiveInfoSubscription) { this.getlocationLiveInfoSubscription.unsubscribe(); }
  }
}
